import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { AnalyzeQueryResponse, SocketAdminMessage, SocketApiResult, SocketData, SocketService } from './socket.service';
import { StoreReadyService } from './store-ready.service';

@Injectable({ providedIn: 'root' })
export class NoopSocketService implements Pick<SocketService, keyof SocketService> {
  public initialized: Promise<void>;
  socketApiResult: Observable<SocketApiResult<any>> = EMPTY;
  notify: Observable<SocketData<any>> = EMPTY;
  msg: Observable<SocketAdminMessage> = EMPTY;
  analyzeQueryResponse$: Observable<AnalyzeQueryResponse> = EMPTY;
  disconnect: Observable<unknown> = of(null);
  onConnection: Observable<string> = of('');

  constructor(
    private storeReady: StoreReadyService,
  ) {
    this.initialized = this.init();
  }

  private async init() {
    await this.storeReady.ready;
  }

  get connected(): boolean {
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  emit(event: string, ...args: any[]): void { }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  subscribe(userIds: string[], companyId: string, detail?: string | string[]): void { }

  resource<T = any>(resource: string, method?: 'post' | 'put' | 'delete'): Observable<SocketData<T>> {
    return EMPTY;
  }

  onceConnected(combinedId?: string): Observable<string> {
    return of(combinedId);
  }
}
